import request from './request'

//仿海草裂变
//我的账号
export function getMyAccount(query) {
  return request({
      url:'/huhushare/Fission/getMyAccount',
      method: 'post',
      data: query
  });
}

//我的账号
export function getMyBalance(query) {
  return request({
      url:'/huhushare/Fission/getMyBalance',
      method: 'post',
      data: query
  });
}


//跑马灯数据
export function getMarquee(query) {
  return request({
      url:'/huhushare/Fissionfake/getMarquee',
      method: 'post',
      data: query
  });
}

//排行榜数据
export function getRank(query) {
  return request({
      url:'/huhushare/Fissionfake/getRank',
      method: 'post',
      data: query
  });
}

//任务中心
export function getMission(query) {
  return request({
      url:'/huhushare/Fissionmission/getMission',
      method: 'post',
      data: query
  });
}

//任务中心 任务完成  领取任务
export function getMissionAward(query) {
  return request({
      url:'/huhushare/Fissionmission/getMissionAward',
      method: 'post',
      data: query
  });
}


//师徒任务 列表
export function getPrenticeAwardList(query) {
  return request({
      url:'/huhushare/Fissionmission/getPrenticeAwardList',
      method: 'post',
      data: query
  });
}

//师徒任务 领取
export function getPrenticeAward(query) {
  return request({
      url:'/huhushare/Fissionmission/getPrenticeAward',
      method: 'post',
      data: query
  });
}

//小伙伴任务列表
export function getPrenticeList(query) {
  return request({
      url:'/huhushare/Fissionmission/getPrenticeList',
      method: 'post',
      data: query
  });
}

//兑换 获取明细记录
export function getRecordList(query) {
  return request({
      url:'/huhushare/Fission/getRecordList',
      method: 'post',
      data: query
  })
}

//获取我的提现卡
export function getMyWithdrawCard(query) {
  return request({
      url:'/huhushare/Fission/getMyWithdrawCard',
      method: 'post',
      data: query
  })
}

//提现
export function withdraw(query) {
  return request({
      url:'/huhushare/Fission/withdraw',
      method: 'post',
      data: query
  })
}

//提现明细
export function getWithdrawRecordList(query) {
  return request({
      url:'/huhushare/Fission/getWithdrawRecordList',
      method: 'post',
      data: query
  })
}

//现金明细
export function getRmbRecord(query) {
  return request({
      url:'/huhushare/Fission/getRmbRecord',
      method: 'post',
      data: query
  })
}



//获取提现规则限制
export function getWithdrawRole(query) {
  return request({
      url:'/huhushare/Fission/getWithdrawRole',
      method: 'post',
      data: query
  })
}

//判断是否关注了公众号
export function wxSubscribe(query) {
  return request({
      url:'/huhushare/Fission/wxSubscribe',
      method: 'post',
      data: query
  })
}

//兑换
export function currencyExchange(query) {
  return request({
      url:'/huhushare/Fission/currencyExchange',
      method: 'post',
      data: query
  })
}

//获取抽奖奖品
export function getLotterySetup(query) {
  return request({
      url:'/huhushare/Fissionlottery/getLotterySetup',
      method: 'post',
      data: query
  })
}

//获取抽奖奖品
export function saveLotteryResult(query) {
  return request({
      url:'/huhushare/Fissionlottery/saveLotteryResult',
      method: 'post',
      data: query
  })
}

//中奖记录
export function getLotteryRecordList(query) {
  return request({
      url:'/huhushare/Fission/getLotteryRecordList',
      method: 'post',
      data: query
  })
}

//获取全额任务
export function getFissionRefundAlbum(query) {
  return request({
      url:'/huhushare/Fissionmission/getFissionRefundAlbum',
      method: 'post',
      data: query
  })
}

//领取全额返现任务奖励
export function getRefundAward(query) {
  return request({
      url:'/huhushare/Fissionmission/getRefundAward',
      method: 'post',
      data: query
  })
}

//获取和1折购任务
export function getFissionDiscountAlbum(query) {
  return request({
      url:'/huhushare/Fissionmission/getFissionDiscountAlbum',
      method: 'post',
      data: query
  })
}

//合成图片
export function compositeFissionPicture(query) {
  return request({
      url:'/huhuapi/images/compositeFissionPicture',
      method: 'post',
      data: query
  })
}

//获取是否已经弹窗
export function getIsShow(query) {
  return request({
      url:'/huhushare/Fission/getIsShow',
      method: 'post',
      data: query
  })
}

//获取是否已经弹窗
export function setIsShow(query) {
  return request({
      url:'/huhushare/Fission/setIsShow',
      method: 'post',
      data: query
  })
}

//统计数据
export function statistics(query) {
  return request({
      url:'/huhushare/FissionStatistics/statistics',
      method: 'post',
      data: query
  })
}

//获取是否已经弹窗
export function getIsBindMobile(query) {
  return request({
      url:'/huhushare/Fissionmission/getIsBindMobile',
      method: 'post',
      data: query
  })
}

//sha1加密
export function getWelfareList(query) {
  return request({
      url:'/huhushare/Fissionvip/getWelfareList',
      method: 'post',
      data: query
  })
}













// WEBPACK FOOTER //
// ./src/api/hcFission.js